(function($){
    // Sub Menu
    var subMenu = function(){
	    if($('.site-navigation .menu > li > .sub-menu').is(':visible')) {
		    if($('.page-content').is(':visible')) {
			    var pageContentOffset = $('.page-content').offset().top;
		    } else {
			   	var pageContentOffset = 0; 
		    }
	      var headerHeight = $('.site-header').outerHeight();
	      var subMenuHeight = $('.site-navigation .menu > li > .sub-menu').outerHeight();
	      var landing = pageContentOffset - headerHeight - subMenuHeight;
	      $(window).scroll(function(){
	          var winST = $(window).scrollTop();
	          var winHeight = $(window).height();
	          var documentHeight = $(document).height();
	          if(winST >= landing) {
	              $('.site-navigation .menu > li > .sub-menu').addClass('scrolled');
	              $('.page-section').each(function(){
	                  var elID = $(this).attr('id');
	                  var elOffset = $(this).offset().top;
	                  var elHeight = $(this).outerHeight();
	                  if(winST >= (elOffset - headerHeight - subMenuHeight) && winST < (elOffset + elHeight - headerHeight - subMenuHeight)){
	                      
	                      if ( $('.site-navigation .anchor > a[href="#' + elID + '"]').height() ) {
	                        $('.site-navigation .anchor > a').removeClass('current');
	                        $('.site-navigation .anchor > a[href="#' + elID + '"]').addClass('current');
	                      }
	                      
	                  }
	                  if(winST >= documentHeight - winHeight) {
	                    $('.site-navigation .anchor > a').removeClass('current');
	                    $('.site-navigation .anchor:last-of-type > a').addClass('current');
	                  }
	              });
	          } else {
	              $('.site-navigation .menu > li.current > .sub-menu').removeClass('scrolled');
	              $('.site-navigation .anchor > a').removeClass('current');
	          }
	      });
	    }
    }
    $(window).load(subMenu);
    $(window).resize(subMenu);
    // Anchors
    $('.site-navigation .anchor > a').click(function(e){
        var href = $(this).attr('href');
        var offset = $(href).offset().top;
        var headerHeight = $('.site-header').outerHeight();
        var subMenuHeight = $('.site-navigation .menu > li > .sub-menu').outerHeight();
        $('html, body').animate({
            scrollTop: offset - headerHeight - subMenuHeight + 1
        }, 250);
        e.preventDefault();
    });
})(jQuery);
